export default "<base-dimension-record-edit params=\"delegate: $data, result: result\"></base-dimension-record-edit>\n";